/**
 * Appends a ".previous" variant for every index whose eval reads the current
 * candle (".current"), so the conditions builder can author cross conditions
 * like `EMA_9.previous<=EMA_50.previous`. Originals stay first: the right-side
 * value matching in VariableInput (endsWith by variable) must keep resolving
 * to the ".current" eval.
 */
function withPreviousVariants(indexes) {
    if (!Array.isArray(indexes)) return indexes;
    const variants = indexes
        .filter(item => item.eval && item.eval.includes('.current'))
        .map(item => ({
            ...item,
            eval: item.eval.replace('.current', '.previous'),
            isPrevious: true,
        }));
    return [...indexes, ...variants];
}

export default withPreviousVariants;
